/*
 * @Author: Merlin
 * @Date: 2024-01-30 10:46:04
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-31 13:53:33
 * @Description: 
 */
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
interface BetForm {
    amount: number;
    isFast: boolean;
    risk: string;
    selected: Array<number>;
    frontID: number;
}

export const useKenoSocket = (rootPath = 'games') => {

    const EMIT_KENO_BET = async (data: BetForm) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        const res = await asyncEmit(
            `${rootPath}.keno.bet`, 
            {...data},
        );
        return res;
    };
    
    return {
        EMIT_KENO_BET
    };
};

